/* esm.sh - applesauce-core@5.2.0/dist/helpers/mailboxes */
export * from "/*applesauce-core@5.2.0/esnext/dist/helpers/mailboxes.mjs";
